import { addDays as f } from "./addDays.js";
import { getISODay as n } from "./getISODay.js";
import { toDate as m } from "./toDate.js";
function i(o, r) {
  const t = m(o), a = n(t), e = r - a;
  return f(t, e);
}
export {
  i as default,
  i as setISODay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setISODay.js
// module id = 1440
// module chunks = 67